import PropTypes from 'prop-types'

const ProgressIndicator = ({ currentStep, totalSteps }) => {
  return (
    <div className="flex gap-spacing-2" role="progressbar" aria-valuenow={currentStep} aria-valuemin={1} aria-valuemax={totalSteps}>
      {[...Array(totalSteps)].map((_, index) => (
        <div
          key={index}
          className={`
            h-4 w-4 border border-border-default rounded-full transition-all duration-300
            ${currentStep === index + 1
              ? 'bg-accent border-pressed'
              : currentStep > index + 1
              ? 'bg-bg-panel'
              : ''
            }
          `}
          aria-hidden="true"
        />
      ))}
    </div>
  )
}

ProgressIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
}

export default ProgressIndicator